<script setup lang="ts">
  import { Skeleton } from '@travelata-libs/ui-kit';

  const TAG_WIDTHS = ['66px', '109px', '100px', '133px', '100px'];
</script>

<template>
  <div
    class="serp-card-skeleton"
    aria-hidden="true"
    data-testid="serp-card-skeleton"
  >
    <div
      class="serp-card-skeleton__media"
      data-testid="serp-card-skeleton-media"
    >
      <Skeleton height="100%" />
    </div>

    <div class="serp-card-skeleton__info">
      <div class="serp-card-skeleton__summary">
        <div class="serp-card-skeleton__stars">
          <Skeleton
            width="120px"
            height="16px"
          />
        </div>

        <div class="serp-card-skeleton__titles">
          <Skeleton
            width="240px"
            height="22px"
          />
          <Skeleton
            width="180px"
            height="20px"
          />
        </div>
      </div>

      <div
        class="serp-card-skeleton__tags"
        data-testid="serp-card-skeleton-tags"
      >
        <Skeleton
          v-for="(width, index) in TAG_WIDTHS"
          :key="index"
          :width="width"
          height="22px"
        />
      </div>

      <Skeleton
        width="140px"
        height="24px"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .serp-card-skeleton {
    background: var(--color-bg-primary);
    border-radius: var(--rounding-xl);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-s);
    padding: var(--spacing-s);
    width: 100%;

    // Радиус медиа (8px) отличается от дефолтного у Skeleton, поэтому обрезаем обёрткой,
    // а не переопределением его собственных стилей.
    &__media {
      border-radius: var(--rounding-m);
      height: 180px;
      overflow: hidden;
      width: 100%;
    }

    &__info {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-s);
    }

    &__summary {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-xs);
    }

    &__stars {
      align-items: center;
      display: flex;
      height: 22px;
    }

    &__titles {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-xxs);
    }

    &__tags {
      display: flex;
      flex-wrap: wrap;
      gap: var(--spacing-xs);
    }
  }
</style>
